import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { StringUtils } from '@grandvisionhq/utils';

const Appointment = ({ appointment  })=>{
    const { dateTime , getLabel  } = useIntl();
    const { id , startTime , store , isVirtualAppointment  } = appointment;
    const appointmentDetailLinkProps = useLink({
        route: 'me.appointments.detail',
        params: {
            appointmentId: id
        }
    });
    var _streetName, _streetNumber;
    return /*#__PURE__*/ React.createElement(Card, swcHelpers.extends({}, appointmentDetailLinkProps), /*#__PURE__*/ React.createElement(Card.Content, {
        childrenWrapperClassName: "profile-appointment-card__wrapper"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        flex: true,
        className: "profile-appointment-card__section"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Card.Icon, {
        name: "calendar",
        height: 32,
        width: 32
    })), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "profile-appointment-card__body"
    }, /*#__PURE__*/ React.createElement(Card.Heading, null, dateTime.formatShortDate(startTime), " ", dateTime.formatTime(startTime)), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary",
        className: "profile-appointment-card__address"
    }, isVirtualAppointment ? getLabel('appointments.virtualAppointmentCall') : store && `${StringUtils.upFirst((_streetName = store.streetName) !== null && _streetName !== void 0 ? _streetName : '')} ${(_streetNumber = store.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : ''}, ${store.town}`)))));
};
Appointment.displayName = 'Appointment';

export { Appointment };
//# sourceMappingURL=Appointment.js.map
